/* @flow */

import React, { Component } from 'react';
import { Provider } from 'react-redux';
import App from '../screens/App';

type Props = {
  store: Object,
  history: Object,
};

export default class Root extends Component {
  props: Props;

  render() {
    const { store, history } = this.props;
    return (
      <Provider store={store}>
        <App history={history} />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/catalog/containers/Root.js